module.exports = __webpack_public_path__ + "img/persona_02.ab7ed0eb.png";